import React, { useState, useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Container from '@mui/material/Container';
import Skeleton from '@mui/material/Skeleton';

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { fetchNavMenus } from '../../reducers/reference_navmenu';
import { fetchClientLogos } from '../../reducers/reference_clientlogo';
import HeaderLogo from './HeaderLogo';
import HeaderMenu from './HeaderMenu';
import { Button, Grid } from '@mui/material';
import { authClear } from '../../reducers/auth';

import { userTimeoutSecondsRemaining, timeoutClear } from '../../reducers/auth_timeout';
import { Print } from '@mui/icons-material';
import { useIdleTimer, workerTimers } from 'react-idle-timer';
import { userKeepAlive } from "../../reducers/auth_timeout";
import { selectSettingForTypeKeyName } from "../../reducers/reference_settings";

const TimeoutHandler = (props) => {
    const { user: currentUser } = useSelector((state) => state.auth) || "";
  const errorMessages = useSelector(state => state.errormessages.entities)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const [remaining, setRemaining] = useState(0)
    const settings = props.settings
    const [open, setOpen] = useState(false)
    const [searchParams] = useSearchParams();
    
    const [timeout, setTimeout] = useState(60000)
    const AreYouThere = errorMessages && errorMessages.filter(x=>{return x.MessageTypeKeyName==="ARE YOU THERE"})
    const promptTimeout = timeout * .5
    const setting_timeoutseconds = useSelector(state=>selectSettingForTypeKeyName(state,{SettingTypeKeyName:'SESSION TIMEOUT SECONDS'}))
    const onPrompt = () => {
        if (currentUser) {
            setOpen(true)
            setRemaining(promptTimeout)
        }
    }

    const onIdle = () => {
        //console.log('idling', currentUser)
        if (currentUser) {
            const whatever = 1
            //setOpen(false)
            // setRemaining(0)
            // dispatch(userLogout())
            // dispatch(authClear())
            // navigate('/logout')
        }
    }
    const onActive = () => {
        dispatch(userKeepAlive())
        setOpen(false)
    }

    const onAction = () => {

        dispatch(userKeepAlive())

    }
    const { getRemainingTime, isPrompted, activate } = useIdleTimer({
        timeout,
        promptTimeout,
        onPrompt,
        onIdle,
        onActive,
        onAction,

        debounce: 10000,
        events: [
            'mousemove',
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown',
            'MSPointerMove',
            'visibilitychange',
            'focus'
        ]
    })

    const {

        timeoutRemaining: timeoutRemaining
        , isTimedOut: isTimedOut
    } = useSelector((state) => state.timeouts)

    const handleStillHere = () => {
        setOpen(false)
        dispatch(userKeepAlive())

        activate()
    }


    useEffect(() => {
        function geTimeoutRemaining() {
            dispatch(userTimeoutSecondsRemaining())
        }
        geTimeoutRemaining()
        const interval = setInterval(() => geTimeoutRemaining(), 60000) //60 seconds
        return () => {
            clearInterval(interval);
        }
    }, [])

    useEffect(() => {

        if (isTimedOut === true && !searchParams.get("pwrg")) {

            dispatch(authClear())
            dispatch(timeoutClear())
            if (location.path !== '/logout') {
                navigate('/logout')
                window.location.reload()
            }
        }
    }, [isTimedOut, dispatch])

    useEffect(() => {

        if (
            setting_timeoutseconds
        ) {
            setTimeout(1000 * parseInt(setting_timeoutseconds, 0))
        }


    }, setting_timeoutseconds)
    return (
        <Modal open={open && ['/logout', '/login'].indexOf(location.pathname) < 0} onClose={handleStillHere}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                border: '2px solid #000',
                color: 'palette.error.main',
                boxShadow: 24,
                pt: 2,
                px: 4,
                pb: 3,
                width: 400,
                textAlign: 'center'
            }}>
                <Typography>{AreYouThere && AreYouThere.length > 0 ? AreYouThere[0].MessageTypeContent : 'ARE YOU THERE'}</Typography>
            </Box>
        </Modal>
    )
}

export default TimeoutHandler